const newContainer = () => import("@/layouts/Default.vue");
const routerParent = () => import("@/layouts/routerParrent.vue");
const myRegisterPersonList = () =>
  import("../views/my-register-person/myRegisterPersonList.vue");

export const extraProfileRoutes: any[] = [
  {
    path: "/extra-profile",
    name: "extra-profile",
    meta: {
      label: "خانه",
      moduleName: "extraProfile",
    },
    component: newContainer,
    children: [
      {
        path: "my-register-person",
        name: "my_register_person",
        component: routerParent,
        redirect: "/extra-profile/my-register-person/list",
        meta: {
          label: "معرفی افراد",
          requiresAuth: true,
          redesigned: true,
        },
        children: [
          {
            path: "list",
            name: "my-register-person-list",
            component: myRegisterPersonList,
            meta: {
              label: "معرفی افراد",
              requiresAuth: true,
              redesigned: true,
            },
          },
        ],
      },
    ],
  },
];
